import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { TOAST_COLORS } from '../../utils/toastColors';

/**
 * Centered confirmation dialog styled to match the app's toast and current theme.
 *
 * Usage:
 *   <ConfirmDialog
 *     isOpen={showConfirm}
 *     title="Delete this post?"
 *     message="This action cannot be undone."
 *     confirmLabel="Delete"
 *     confirmDanger
 *     onConfirm={handleConfirm}
 *     onCancel={() => setShowConfirm(false)}
 *   />
 */
const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmDanger = false,
  onConfirm,
  onCancel,
}) => {
  const { currentTheme } = useTheme();
  const colors = TOAST_COLORS[currentTheme] || TOAST_COLORS.light;

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
      onClick={onCancel}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: colors.bg,
          color: colors.text,
          border: `1px solid ${colors.border}`,
          borderRadius: '10px',
          padding: '16px 20px',
          minWidth: '260px',
          maxWidth: '320px',
          width: '90%',
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
        }}
      >
        {title && (
          <p style={{ color: colors.text, fontWeight: 600, fontSize: '0.875rem', marginBottom: '4px' }}>
            {title}
          </p>
        )}
        {message && (
          <p style={{ color: colors.text, opacity: 0.65, fontSize: '0.75rem', marginBottom: '16px' }}>
            {message}
          </p>
        )}
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '6px 14px',
              fontSize: '0.75rem',
              borderRadius: '6px',
              border: `1px solid ${colors.border}`,
              background: 'transparent',
              color: colors.text,
              cursor: 'pointer',
            }}
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '6px 14px',
              fontSize: '0.75rem',
              borderRadius: '6px',
              border: 'none',
              background: confirmDanger ? '#ef4444' : '#3b82f6',
              color: '#ffffff',
              cursor: 'pointer',
              fontWeight: 500,
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
